module.exports = __webpack_public_path__ + "static/media/300x250_0006_ru.5ef2191d.jpg";